import React, { useEffect, useState } from "react";
import { JAPIPublicationLoader } from "pages/latestResearch/publications/JAPIPublicationLoader";
import { ViewLayout } from "pages/latestResearch/publications/ViewLayout";
import { Tab, Tabs } from "react-bootstrap";
import { push, addParam, removeParam, getQueryString, setParam } from "pages/search/api/filterUrlMaker";
import { Events } from "pages/events/Events";
import { _t } from "app/i18n/i18n";
import { Coverage } from "../../coverage/Coverage";
import { useCoverageData } from "../../coverage/data/CoverageDataProvider";

const onTabChange = (key) => {
  const queryParams = getQueryString();
  const filteredParams = Object.fromEntries(Object.entries(queryParams).filter(([param]) => param === "Analyst"));

  if (key === "videos") {
    push(addParam("contentType.en", "Webcast", filteredParams));
  } else {
    push(key === "events" ? filteredParams : removeParam("contentType.en", "Webcast", filteredParams));
  }

  push(addParam("Tab", key));
};

export function AnalystProfileTabs({ profile, isMobile = false }) {
  const { rows } = useCoverageData();
  const hasEquityCoverage = rows?.length > 0;
  const queryParams = getQueryString();

  useEffect(() => {
    const hasEquityTimeout = setTimeout(() => {
      if (!queryParams.Tab) {
        if (hasEquityCoverage) {
          push(setParam("Tab", "Equity"));
        } else {
          push(setParam("Tab", "publications"));
        }
      }
    }, 1500);
    setDefaultActiveTab(queryParams.Tab);

    return () => clearTimeout(hasEquityTimeout);
  }, [hasEquityCoverage]);

  const [defaultActiveTab, setDefaultActiveTab] = useState("");

  return (
    <section className="mx-3 mt-5">
      <hr />
      <Tabs
        activeKey={defaultActiveTab}
        className={isMobile ? "mb-2 flex-md-row " : "mb-2 flex-column flex-md-row"}
        onSelect={(key) => {
          setDefaultActiveTab(key);
          onTabChange(key);
        }}
      >
        {hasEquityCoverage && (
          <Tab eventKey="Equity" title={_t("Equity Coverage")}>
            <Coverage showFilters={false} />
          </Tab>
        )}
        <Tab eventKey="publications" title={_t("Publications")}>
          <Publications />
        </Tab>
        <Tab eventKey="events" title={_t("Events")} tabClassName={profile.eventCount > 0 ? "" : "d-none"}>
          <Events showHeader={false} pastEventDate="1year" />
        </Tab>
        <Tab eventKey="videos" title={_t("Webcasts")} tabClassName={profile.videoCount > 0 ? "" : "d-none"}>
          <Publications />
        </Tab>
      </Tabs>
      <hr />
    </section>
  );
}

function Publications() {
  return (
    <JAPIPublicationLoader
      scrollToTop={false}
      render={(publications, _noop, data) => <ViewLayout publications={publications} data={data} hideAds />}
    />
  );
}
